// extracted by mini-css-extract-plugin
export default {"select":"TableSelect_select__6C2uC"};